import { useState } from "react";
import { Clock } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { cn } from "@/lib/utils";

// Native <input type="time"> follows the browser locale (often 12h AM/PM).
// This picker always uses 24-hour format, storing/emitting "HH:mm".
const pad = (n) => String(n).padStart(2, "0");
const HOURS = Array.from({ length: 24 }, (_, i) => pad(i));
const MINUTES = Array.from({ length: 60 }, (_, i) => pad(i));

export function TimeField({ value, onChange, placeholder = "--:--", className, testid }) {
  const [open, setOpen] = useState(false);
  const [h, m] = value && value.includes(":") ? value.split(":") : ["", ""];
  const emit = (nh, nm) => onChange(`${nh || "00"}:${nm || "00"}`);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className={cn(
            "flex h-10 w-full items-center gap-2 rounded-md border border-brand-line bg-white px-3 py-2 text-left text-sm transition focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold",
            !value && "text-brand-muted",
            className
          )}>
          <Clock className="h-4 w-4 shrink-0 text-brand-muted" />
          <span className="truncate">{value || placeholder}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-3" align="start">
        <div className="flex items-center gap-2">
          <Select value={h} onValueChange={(nh) => emit(nh, m)}>
            <SelectTrigger className="w-20 focus:ring-brand-gold" data-testid={testid ? `${testid}-hour` : undefined}><SelectValue placeholder="Jam" /></SelectTrigger>
            <SelectContent className="max-h-60">{HOURS.map((x) => <SelectItem key={x} value={x}>{x}</SelectItem>)}</SelectContent>
          </Select>
          <span className="font-bold text-brand-espresso">:</span>
          <Select value={m} onValueChange={(nm) => emit(h, nm)}>
            <SelectTrigger className="w-20 focus:ring-brand-gold" data-testid={testid ? `${testid}-minute` : undefined}><SelectValue placeholder="Menit" /></SelectTrigger>
            <SelectContent className="max-h-60">{MINUTES.map((x) => <SelectItem key={x} value={x}>{x}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      </PopoverContent>
    </Popover>
  );
}
